import { render, staticRenderFns } from "./ECommerceAddProductcomment.vue?vue&type=template&id=2faa8a84&scoped=true&"
import script from "./ECommerceAddProductcomment.vue?vue&type=script&lang=js&"
export * from "./ECommerceAddProductcomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa8a84",
  null
  
)

export default component.exports